import { useAuth0 } from '@yuno/dashboard-authentication-mfe'
import { queryClient } from '@yuno/dashboard-api-mfe'

export const useLogout = () => {
  const { logout } = useAuth0()

  const handleLogout = () => {
    const event = new CustomEvent('LOGOUT_EVENT')
    window.dispatchEvent(event)

    localStorage.removeItem('UI_CONFIG')
    localStorage.removeItem('isTesting')
    localStorage.removeItem('token')
    localStorage.removeItem('headers')
    localStorage.removeItem('x-organization-code')
    localStorage.removeItem('paymentsSearchParams')
    localStorage.removeItem('transactionsSearchParams')

    queryClient.removeQueries()

    logout({ returnsTo: `${window.location.origin}/auth` })
  }

  const isNotAuth = (data) => {
    if (data?.response?.status === 401) handleLogout()
  }

  return {
    handleLogout,
    isNotAuth,
  }
}
